import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    GridContainer,
    GridItem8sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    informouConsideracoesFinais,
} from '../consideracoesFinais-form/ConsideracoesFinaisService'



const EstudoReportPrimeiraReuniaoClienteConfiguracao = ({ values, handleChange, handleSubmit, linhaTipoLicenca, linhaFormList }) => {

    return (
        
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem8sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <GridContainer>
                                <GridItem12
                                    align='left'
                                    //className='mb--1'
                                >
                                    <CheckboxPadrao
                                        name="exibirCapacidadePoupancaRelatorio"
                                        label={LABEL.exibirCapacidadePoupancaRelatorio}
                                        checked={values.exibirCapacidadePoupancaRelatorio}
                                        onChange={handleChange}
                                    />
                                </GridItem12>

                                <GridItem12
                                    align='left'
                                    className='mt--4 mb--1'
                                >
                                    <CheckboxPadrao
                                        name="exibirAportesRetiradasPlanejadosRelatorio"
                                        label={LABEL.exibirAportesRetiradasPlanejadosRelatorio}
                                        checked={values.exibirAportesRetiradasPlanejadosRelatorio}
                                        onChange={handleChange}
                                    />
                                </GridItem12>

                                <GridItem12
                                    align='left'
                                    className='mt--4 mb--1'
                                >
                                    <CheckboxPadrao
                                        name="naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira"
                                        label={LABEL.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira}
                                        checked={values.naoExibirGraficoDiagnosticoAposentadoriaIndependenciaFinanceira}
                                        onChange={handleChange}
                                    />
                                </GridItem12>

                                <GridItem12
                                    align='left'
                                    className='mt--4 mb--1'
                                >
                                    <CheckboxPadrao
                                        name="naoExibirEvolucaoReservaFinanceira"
                                        label={LABEL.naoExibirEvolucaoReservaFinanceira}
                                        checked={values.naoExibirEvolucaoReservaFinanceira}
                                        onChange={handleChange}
                                    />
                                </GridItem12>
                                
                                {linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === 'S' && (
                                    <GridItem12
                                        align='left'
                                        className='mt--4 mb--1'
                                    >
                                        <CheckboxPadrao
                                            name="exibirProtecaoSugeridaRelatorio"
                                            label={LABEL.exibirProtecaoSugeridaRelatorio}
                                            checked={values.exibirProtecaoSugeridaRelatorio}
                                            onChange={handleChange}
                                        />
                                    </GridItem12>
                                )}

                                <GridItem12
                                    align='left'
                                    className='mt--4 mb--1'
                                >
                                    <CheckboxPadrao
                                        name="exibirSucessaoVitaliciaRelatorio"
                                        label={LABEL.exibirSucessaoVitaliciaRelatorio}
                                        checked={values.exibirSucessaoVitaliciaRelatorio}
                                        onChange={handleChange}
                                    />
                                </GridItem12>

                                <GridItem12
                                    align='left'
                                    className='mt--4 mb--1'
                                >
                                    <CheckboxPadrao
                                        name="exibirComparacaoCenariosRelatorio"
                                        label={LABEL.exibirComparacaoCenariosRelatorio}
                                        checked={values.exibirComparacaoCenariosRelatorio}
                                        onChange={handleChange}
                                    />
                                </GridItem12>

                                {values.exibirComparacaoCenariosRelatorio && (
                                    <GridItem12
                                        align='left'
                                        className='mt--4 mb--1'
                                    >
                                        <CheckboxPadrao
                                            name="exibirComparacaoCenariosRelatorioSemTabelaGrafico"
                                            label={LABEL.exibirComparacaoCenariosRelatorioSemTabelaGrafico}
                                            checked={values.exibirComparacaoCenariosRelatorioSemTabelaGrafico}
                                            onChange={handleChange}
                                        />
                                    </GridItem12>
                                )}

                                {values.jsonComparacaoEstudos.estudos.length > 1 && (
                                    <GridItem12
                                        align='left'
                                        className='mt--4 mb--1'
                                    >
                                        <CheckboxPadrao
                                            name="exibirComparacaoEstudosRelatorio"
                                            label={LABEL.exibirComparacaoEstudosRelatorio}
                                            checked={values.exibirComparacaoEstudosRelatorio}
                                            onChange={handleChange}
                                        />
                                    </GridItem12>
                                )}

                                {informouConsideracoesFinais(values) && (
                                    <GridItem12
                                        align='left'
                                        className='mt--4 mb--1'
                                    >
                                        <CheckboxPadrao
                                            name="exibirConsideracoesFinaisRelatorio"
                                            label={LABEL.exibirConsideracoesFinaisRelatorio.replace('$1$',
                                                linhaFormList.labelTabClienteFormListConsideracoesFinais)
                                            }
                                            checked={values.exibirConsideracoesFinaisRelatorio}
                                            onChange={handleChange}
                                        />
                                    </GridItem12>
                                )}
                            </GridContainer>
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </GridItem8sm12xs12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default EstudoReportPrimeiraReuniaoClienteConfiguracao